const o = (e) => {
  switch (e) {
    case "payouts":
      return "weCouldNotLoadThePayoutsOverview";
    case "transactions":
      return "weCouldNotLoadTheTransactionsOverview";
    case "transactionDetails":
      return "weCouldNotLoadYourTransactions";
    case "payoutDetails":
      return "weCouldNotLoadYourPayouts";
    case "reports":
      return "weCouldNotLoadTheReportsOverview";
    default:
      return "somethingWentWrong";
  }
};
export {
  o as default
};
